// extracted by mini-css-extract-plugin
module.exports = {"gradient":"A0"};